import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ensureApiKey } from './services/auth/keyBroker';
import './styles/global.scss';
import { registerOfficeActions } from './officeActions';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

Office.onReady(() => {
  // Shared runtime: keyboard shortcuts dispatch into THIS page (see officeActions).
  registerOfficeActions();
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  // Fire-and-forget: provision a per-user key via the broker if none is stored
  // and NAA is available. Never blocks render; failures fall back to manual key.
  void ensureApiKey().catch(() => undefined);
  // Fire-and-forget: refresh the org playbooks from SharePoint (cache-first;
  // offline or unconsented hosts keep the bundled standards). Lazy import so
  // the Graph code stays out of the critical path.
  void import('./services/playbooks/sharePointStore')
    .then((m) => m.syncOrgPlaybooks())
    .catch(() => undefined);
});
